export const handleCopyError = (curl, setOpenSnackbar) => {
    navigator.clipboard?.writeText(curl)
    setOpenSnackbar(true)
  }
  